import { Tabs } from 'antd';
import React from 'react';
import DevListTab from '../components/Settings/components/DevListTab';
import FilterList from '../components/Settings/components/FilterList';
import SettingsList from '../components/Settings/components/SettingsList';
import PageLayout from '../layouts/PageLayout';

const SettingsPage: React.FC = () => {
  return (
    <PageLayout title="Auto Tab Opening Settings" backTo="/">
      <Tabs
        items={[
          {
            key: 'settings',
            label: 'Settings',
            children: <SettingsList />,
          },
          {
            key: 'filters',
            label: 'Filters',
            children: <FilterList />,
          },
          {
            key: 'dev-white-list',
            label: 'White List',
            children: (
              <DevListTab
                listKey="devWhiteList"
                description="Addresses and twitter names added here will be shown and opened independently on filters."
              />
            ),
          },
          {
            key: 'dev-black-list',
            label: 'Black List',
            children: (
              <DevListTab
                listKey="devBlackList"
                description="Addresses and twitter names listed here will be filtered out. One item per line."
              />
            ),
          },
        ]}
      />
    </PageLayout>
  );
};

export default SettingsPage;
